import React from 'react'
import { css } from '@emotion/core'
import { ContentCheck } from '@fs/zion-icon/dist/cjs/icons'
import PropTypes from 'prop-types'
import { colors } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'

const containerStyle = css`
  position: absolute;
  background: ${colors.gray00};
  border: 2px solid ${colors.gray90};
  bottom: 5px;
  border-radius: 20px;
  inset-inline-end: 5px;
  display: flex;
  flex-direction: row;
  align-items: center;
`

const iconWrapperStyle = css`
  background: ${colors.gray00};
  padding: 0 4px;
  bottom: 0px;
  border-radius: 50%;
  inset-inline-end: 0;
`

const withOutCountStyle = css`
  padding: 0;
`

const countTextStyle = css`
  margin-inline-end: 8px;
  color: ${colors.gray90};
`

export const CompletedCountIndicator = ({ count, activityGroupId, personId }) => {
  const [t] = useTranslation()

  return (
    <div
      css={containerStyle}
      id={`card-completed-count-${personId ?? activityGroupId}`}
      aria-label={t('cardslider.card.prev-answer-count', { count })}
    >
      <div css={count > 1 ? iconWrapperStyle : withOutCountStyle}>
        <ContentCheck color={colors.gray90} />
      </div>
      {count > 1 && <div css={countTextStyle}>{count > 98 ? '99+' : count}</div>}
    </div>
  )
}

CompletedCountIndicator.propTypes = {
  count: PropTypes.number,
}
